/*
 * Module for a list of topics
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topics/topicsList/topicsListView",
  "modules/shared/sortableList/sortableListModule",
  "modules/topicsSplit/topics/topicsList/topicsControls/topicsControlsModule",
], function (Marionette, Messenger, TopicsListView, SortableListModule, TopicsControlsModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicsList";
      this.region = options.region;
      this.rootTopicGroup = options.rootTopicGroup;
      this.namespace = options.namespace;
      this.group = null; //group being shown in the topic list
      this._setUpVents();
    },
    show: function (groupModel, options) {
      this.showArchivedTopics = options.showArchivedTopics;
      this.showButtons = options.showButtons;
      this.showButtonsForArchived = options.showButtonsForArchived;
      this.group = groupModel;
      const headers = Messenger.reqres.request("topics:headers");
      this.layout = new TopicsListView.topicsListLayout();
      this.controls = this.addSubModule(
        new TopicsControlsModule({
          region: this.layout.controls,
          showArchivedTopics: this.showArchivedTopics,
          showButtons: this.showButtons,
          showButtonsForArchived: this.showButtonsForArchived,
          namespace: this.namespace,
        }),
      );
      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: this.namespace,
        }),
      );
      this.layout.on("show", () => this._showSubViews(groupModel));
      this.showRegion(this.layout);
    },
    _showSubViews: function (groupModel) {
      this.controls.show(groupModel, this.rootTopicGroup);
      if (this.showArchivedTopics) {
        this.list.show(groupModel.archivedTopics());
      } else {
        this.list.show(groupModel.topics());
      }
    },
    _setUpVents: function () {
      //a row was selected in the sortable list (prepend namespace)
      Messenger.vent.on(
        Messenger.getFullName("selected:row", this.namespace),
        function (model) {
          Messenger.save(function (success) {
            if (success) {
              console.log("selected " + model.get("intentName"));
              Messenger.vent.trigger("show:topic", model); //show topic page
            }
          }, this);
        },
        this,
      );

      //dragged and dropped a mart transcript to a topic, so open the topic page, then add the utterance as an example
      Messenger.vent.on(
        Messenger.getFullName("dropped:on:row", this.namespace),
        function (transcript, topicModel) {
          Messenger.save(function (success) {
            if (success) {
              const learnerConfig = Messenger.reqres.request("learner:config:settings");
              Messenger.vent.trigger("show:topic", topicModel); //show topic page
              //fire an event for the topic module to handle applying the transcript to the topic
              Messenger.vent.once("topic:fully:loaded", () =>
                Messenger.vent.trigger(
                  "apply:transcript:to:topic",
                  transcript,
                  learnerConfig.localeId,
                ),
              );
            }
          }, this);
        },
        this,
      );
    },
  });
});
